<template>
  <div v-scroll="widScroll">
    <div v-if="infoUrl() == '/'" class="grad" :style="{width: wid + '%'}"></div>
    <v-col class="pr-7 pt-0">
      <v-row>
        <v-app-bar class="pa-0" absolute color="rgba(0,0,0,0)" flat style="z-index:10" height="100">
          <v-container fluid class="d-none d-lg-flex pa-0" style="margin-left:5%; width:90%;">
            <v-col cols="2" class="pa-0">
              <v-row>
                <div class="font-weight-black" style="font-size:1.5vw;">Проект Успеха</div>
              </v-row>
              <v-row>
                <v-dialog v-model="dialog">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon>mdi-map-marker</v-icon>
                    <v-btn
                      dense
                      class="text-capitalize"
                      text
                      v-bind="attrs"
                      v-on="on"
                    >{{$store.state.city}}</v-btn>
                  </template>

                  <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>Выбор Города</v-card-title>
                    <v-row class="ma-0">
                      <v-text-field v-model="incity"></v-text-field>
                    </v-row>
                    <v-row class="ma-0">
                      <v-main class="d-none d-md-flex">
                        <v-row class="ma-0">
                          <v-col
                            cols="2"
                            align="center"
                            v-for="(item, index) in filterItems(incity)"
                            :key="item"
                          >
                            <v-btn small text @click="sitch(item)">{{item}}</v-btn>
                            <v-divider :key="index"></v-divider>
                          </v-col>
                        </v-row>
                      </v-main>
                    </v-row>
                  </v-card>
                </v-dialog>
              </v-row>
            </v-col>

            <v-col cols="3" align="start" class="pt-3 pa-0">
              <v-btn text dense @click="jump('/Projects')">Проекты</v-btn>
              <v-btn text dense @click="jump('/Search')">Поиск</v-btn>
            </v-col>

            <v-col cols="7" class="pt-3 pa-0 d-flex d-inline-block justify-end">
              <v-btn text dense @click="jump('/')">Главная</v-btn>
              <Insys />
              <v-btn text dense @click="jump('/Reg')" v-if="!$store.state.inAk">Регистрация</v-btn>
              <v-btn
                v-if="$store.state.inAk"
                depressed
                color="rgba(255, 0, 0, 0.0)"
                @click="jump('/Message/1')"
                x-small
                fab
              >
                <v-icon dense>mail_outline</v-icon>
              </v-btn>

              <v-menu open-on-hover bottom left offset-y v-if="$store.state.inAk">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn depressed small fab v-bind="attrs" v-on="on" color="rgba(255, 0, 0, 0.0)">
                    <v-icon large dense v-if="!haveAv">account_circle</v-icon>
                    <v-avatar color="grey" size="32" v-else>
                      <v-img :src="$ls.get('avatar')"></v-img>
                    </v-avatar>
                  </v-btn>
                </template>
                <v-card color="grey lighten-4" outlined>
                  <v-col>
                    <v-row class="px-4" justify="end">{{Fio()}}</v-row>
                    <v-divider></v-divider>
                    <v-row class="px-1 py-1" justify="end">
                      <v-btn
                        dense
                        :ripple="false"
                        text
                        @click="jump('/Lk/1')"
                        class="text-capitalize"
                      >Личный кабинет</v-btn>
                    </v-row>
                    <v-row class="px-1 py-1" justify="end">
                      <v-btn
                        dense
                        :ripple="false"
                        text
                        @click="jump('/' + $ls.get('idNam'))"
                        class="text-capitalize"
                      >Моя карта</v-btn>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row class="px-1 pt-1" justify="end">
                      <v-btn :ripple="false" text @click="exit()" class="text-capitalize">
                        <v-icon size="20">exit_to_app</v-icon>Выйти
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-card>
              </v-menu>
            </v-col>
          </v-container>

          <v-container absolute fluid class="d-xs-flex d-lg-none mt-n12 mx-auto overflow-hidden">
            <v-row align="center">
              <v-col cols="1" class="pa-0">
                <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
              </v-col>
              <v-col>
                <v-toolbar-title class="text-body-2 font-weight-black">Проект Успеха</v-toolbar-title>
              </v-col>

              <v-col>
                <v-row align="center" justify="end">
                  <Insys />
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-app-bar>

        <v-navigation-drawer v-model="drawer" absolute temporary style="z-index:12">
          <v-list nav dense>
            <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">
              <v-list-item v-for="panel in VisPanel" :key="panel.icon" @click="jump(panel.way)">
                <v-list-item-icon>
                  <v-icon>{{panel.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{panel.title}}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>
      </v-row>
      <v-row justify="center">
        <v-main>
          <slot style="overflow:scroll"></slot>
        </v-main>
      </v-row>
      <v-row class="pt-16 mt-16" v-if="infoUrl() != '/Reg'">
        <v-footer absolute padless>
          <v-card flat tile width="100%" color="#F1F4FB" class="text-center">
            <v-card-text>
              <v-btn v-for="icon in icons" :key="icon" class="mx-4" icon>
                <v-icon size="24px">{{ icon }}</v-icon>
              </v-btn>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text class="black--text">
              {{ new Date().getFullYear() }} —
              <strong>Vuetify</strong>
            </v-card-text>
          </v-card>
        </v-footer>
      </v-row>
    </v-col>
  </div>
</template>


<script>
import Insys from "./Additional/InSys";
import { Exemplemix } from "../mixinEx";
export default {
  mixins: [Exemplemix],
  components: {
    Insys,
  },
  data: () => ({
    cur: false,
    panels: [
      {
        icon: "mdi-home",
        way: "/",
        title: "Главная",
        visible: "all",
      },
      {
        icon: "assignment_late",
        way: "/Projects",
        title: "Проекты",
        visible: "all",
      },
      {
        icon: "search",
        way: "/Search",
        title: "Поиск",
        visible: "all",
      },
      {
        icon: "vpn_key",
        way: "/Reg",
        title: "Регистрация",
        visible: "none",
      },
      {
        icon: "mail_outline",
        way: "/Message/1",
        title: "Сообщения",
        visible: "yes",
      },
      {
        icon: "mdi-account-cog-outline",
        way: "/Lk/1",
        title: "Аккаунт",
        visible: "yes",
      },
      {
        icon: "mdi-account",
        way: "",
        title: "Моя карта",
        visible: "yes",
      },
      {
        icon: "exit_to_app",
        way: "exit",
        title: "Выйти",
        visible: "yes",
      },
    ],
    items: [
      "Абакан",
      "Азов",
      "Александров",
      "Алексин",
      "Альметьевск",
      "Южно-Сахалинск",
      "Юрга",
      "Якутск",
      "Ялта",
      "Ярославль",
    ],
    login: "",
    password: "",
    group: undefined,
    drawer: false,
    city: "Город",
    dialog: false,
    dialog2: false,
    dialog3: false,
    snackbar: false,
    incity: "",
    wid: 0,
    LastName: "",
    dis: false,
    Name: "",
    Otc: "",
    step: 1,
    color_app: "rgba(255, 0, 0, 0.0)",
    icons: ["mdi-home", "mdi-email", "mdi-calendar", "mdi-delete"],
  }),

  created() {
    if (this.$ls.get("inAk") == undefined) {
      return "";
    } else {
      var a = this.$ls.get("fio").split("_");
      this.LastName = a[0];
      this.Name = a[1];
      this.Otc = a[2];
    }
    if (location.pathname == "/index.html") {
      this.$router.replace(this.$ls.get("url"));
    }
    this.$store.state.inAk = Boolean(this.$ls.get("inAk"));
    if (this.$store.state.inAk == true) {
      this.panels[6].way = this.$ls.get("idNam");
    }
  },

  computed: {
    VisPanel() {
      if (this.$store.state.inAk == false) {
        return this.panels.filter(
          (t) => t.visible == "all" || t.visible == "none"
        );
      } else {
        return this.panels.filter(
          (t) => t.visible == "all" || t.visible == "yes"
        );
      }
    },
    haveAv() {
      if (this.$ls.get("avatar") != undefined) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    widScroll() {
      var scrollHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
      );
      const totalHeight = scrollHeight - window.innerHeight;
      this.wid = (window.pageYOffset / totalHeight) * 100;
    },
    Fio() {
      if (this.$ls.get("inAk") == undefined) {
        return "";
      } else {
        var value =
          this.LastName +
          " " +
          this.Name.charAt(0).toUpperCase() +
          ". " +
          this.Otc.charAt(0).toUpperCase() +
          ".";
        return value;
      }
    },
    sitch(e) {
      this.$store.state.city = e;
      this.dialog = false;
    },
    filterItems(query) {
      return this.items.filter(function (el) {
        return el.toLowerCase().indexOf(query.toLowerCase()) > -1;
      });
    },
  },

  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>

<style>
div.grad {
  position: fixed;
  top: 0;
  left: 0;
  height: 5px;
  background: linear-gradient(to left, #008aff, #00ffe7);
  z-index: 999;
  animation: gradient 10s linear infinite;
}

@keyframes gradient {
  0% {
    filter: hue-rotate(0deg);
  }
  50% {
    filter: hue-rotate(360deg);
  }
  100% {
    filter: hue-rotate(0deg);
  }
}
div.grad:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, #008aff, #00ffe7);
  z-index: 999;
  filter: blur(5px);
}
div.grad:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, #008aff, #00ffe7);
  z-index: 999;
  filter: blur(10px);
}
</style>